import { CommonModule, DatePipe, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Injector, OnDestroy, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router, RouterOutlet } from '@angular/router';
import { ISOCountryCode } from '@core/enums/ISO-country-code.enum';
import { environment } from '@env/environment';
import { TranslateService } from "@ngx-translate/core";
import { BaseComponent } from '@pages/base/base.component';
import { BaseInnerComponent } from '@pages/partial/base-inner/base-inner.component';
import { WidgetComponent } from '@pages/partial/widget/widget.component';
import { LogoFaviconHttpService } from '@core/services/logo-favicon-http.service';
import { SupportChatService } from '@core/services/support-chat.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DynamicFooterComponent } from '@pages/partial/dynamic-footer/dynamic-footer.component';
import { delay, filter, finalize, forkJoin, interval, Observable, of, Subscription, tap } from 'rxjs';
import { svgIconList } from '@shared/svg-icon-list';
import { ShowChangeCountryNoticeKey } from '@shared/session-storage.key';
// ng-connection-service removed from static import (crashes SSR due to top-level window access)
// Dynamically imported in onCheckConnection() only in browser
interface ConnectionState {
  hasNetworkConnection: boolean;
  hasInternetAccess: boolean;
}
import { Announcement } from '@shared/models/announcement.model';
import { AppState } from '@store/reducers';
import { select, Store } from '@ngrx/store';
import { Title } from '@angular/platform-browser';
import { AuthHttpService } from '@core/entity/auth/service/auth.http.service';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { DomainService } from '@core/services/domain.service';
import { GameCategoryDataService } from '@core/services/games/gamecategory-data.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AnnouncementHttpService } from '@core/services/announcement-http.service';
import { LocationHttpService } from '@core/services/location-http.service';
import { EmailVerificationHttpService } from '@core/services/verify-email-http.service';
import { SEOHttpService } from '@core/entity/seo/service/seo.http.service';
import { SeoService } from '@core/services/seo.service';
import { ContactListHttpService } from '@core/services/contact-list-http.service';
import { PromotionContentDataService } from '@pages/promotion/services/promotion-content-data.service';
import { SiteHttpService } from '@core/services/site-http.service';
import { WalletHttpService } from '@core/services/wallet-http.service';
import { BankHttpService } from '@core/services/bank-http.service';
import { GameCategoryHttpService } from '@core/services/game-category-http.service';
import { MerchantBankHttpService } from '@core/services/merchant-bank-http.service';
import { BankAccountDataService } from '@pages/portal/subcomponents/portal-bank/services/bank-account-data.service';
import { LiveChatHttpService } from '@core/services/livechat-http-service';
import { BonusListWebsocketService } from '@core/services/bonus-list-websocket.service';
import { TransactionStatusUpdateService } from '@core/services/transaction-status-update.service';
import { MatDialog } from '@angular/material/dialog';
import { DashboardService } from '@core/services/dashboard.service';
import { SharedService } from '@core/services/shared.service';
import { FirebaseMessagingService } from '@core/services/firebase-messaging.service';
import { canAskPushWithoutTap } from '@shared/utils/pwa-display-mode.util';
import { PortalMemberProfileHttpService } from '@core/services/portal-member-profile-http.service';
import { WSSEventSettingDataService } from '@core/services/wss-event-setting-data.service';
import { SocketIoService } from '@core/services/socket.io-service';
import { HttpClient } from '@angular/common/http';
import { TldService } from '@core/services/tld.service';
import { Login, Logout } from '@core/entity/auth/state/auth.actions';
import { Crisp } from "crisp-sdk-web";
import { IsLoggedIn } from '@core/entity/auth/state/auth.selectors';
import { ClarityService } from '@core/services/clarity.service';
import { NewDepositHttpService } from '@core/services/new-deposit-http.service';
import { NewTwostepDepositDataService } from '@core/services/new-twostep-deposit-data.service';
import { Marquees } from '@shared/marquees.model';
import { PopupServiceWorkerComponent } from '@shared/popup-service-worker/popup-service-worker.component';
import countryISOMapping from 'country-iso-3-to-2';
import Swal from 'sweetalert2';
import { InsufficientModalModalComponent } from '@shared/insufficient-funds-modal/insufficient-funds-modal.component';
import { PopupAnnouncementComponent } from '@shared/popup-announcement/popup-announcement.component';
import { RequestReceiptComponent } from '@shared/request-receipt/request-receipt.component';
import { FloatingRewardComponent } from '@shared/floating-reward/floating-reward.component';

declare var $: any;
declare const window: any;
declare var gtag: any;

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonModule, BaseComponent, BaseInnerComponent, WidgetComponent, DynamicFooterComponent, PopupAnnouncementComponent, RequestReceiptComponent, FloatingRewardComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {

  siteName = environment.siteName;
  // defaultCountryCode = environment.defaultCountryCode;
  pageTitle = '';
  isMobileDetected = false;
  maintenanceDateTime: string = null;
  currentURL: any;
  page = '';

  announcements$: any[] = [];
  announcementIds: any[] = [];
  campaignCode: string;
  affiliateCode: string;
  affiliateCampaignCode: string;
  todayDate = new Date();

  ISOCountryCode: any = ISOCountryCode;

  showChangeCountryNotice = false;
  unsubscribeForceLogout: (() => void) | null = null;
  countryCode: string;
  hostname = '';
  countryDomain: string;
  countryCodeToChange = 'MY';
  isBrowser: boolean;

  supportedCountry: any;
  seo: any;
  hideAppBaseList = ['/unsupported-country', '/gamelaunch2', '/processing-transaction'];
  hideAppBase: boolean;
  isLoggedIn$: Observable<boolean>;
  mainDomainBlocked: Boolean;
  bothDomainBlocked: Boolean;
  currentDomain: string;
  username: string;
  password: string;
  currentCountry: string = null;
  seoSetting: any;
  siteDomain: any = null;

  isShowFooter = false;
  inSufficientPopup = true;
  seenAnnouncementsProbed = false;

  get isLandingRoute(): boolean {
    const url = this.router?.url || '';
    const pathOnly = url.split('?')[0];
    return pathOnly === '/' || pathOnly === '/landing' || pathOnly === '/thank-you' || url.includes('/thank-you');
  }

  // Paths where announcement popups must never show. Keep in sync with the mobile app.component.
  noPopupPaths = ['/', '/landing', '/thank-you', '/unsupported-country'];

  // Reads window.location, not router.url: router.url is still '/' until the first navigation
  // ends, so the page-load calls in ngOnInit would wrongly treat every page as landing.
  get isNoPopupRoute(): boolean {
    const path = window.location.pathname;
    return this.noPopupPaths.includes(path) || path.includes('/thank-you');
  }

  // TEMPORARILY
  s3RedirectURL: any = {
    '/EN50FSD': 'https://aiodin-pro1.s3.ap-southeast-1.amazonaws.com/promotion/#COUNTRY_LANGUAGE+-+50+Free+Spins+-+Deposit.png',
    '/EN50FSND': 'https://aiodin-pro1.s3.ap-southeast-1.amazonaws.com/promotion/#COUNTRY_LANGUAGE+-+50+Free+Spins+-+No+Deposit.png',
    '/ZH50FSD': 'https://aiodin-pro1.s3.ap-southeast-1.amazonaws.com/promotion/#COUNTRY_LANGUAGE+-+50+Free+Spins+-+Deposit.png',
    '/ZH50FSND': 'https://aiodin-pro1.s3.ap-southeast-1.amazonaws.com/promotion/#COUNTRY_LANGUAGE+-+50+Free+Spins+-+No+Deposit.png'
  }
  pathName = '';

  svg: any = svgIconList;
  supportedLanguage: any;

  widget: any;
  CloseWidgetCounter: number = 0;
  previousRoute: any;

  connectionState!: ConnectionState;
  connectionSubscription = new Subscription();
  announcementSubscription = new Subscription();

  
  // Matched by `name` against the URL path segments in onSwalFire(); each value must equal the
  // `location_name` api2 returns for that page (source of truth: api2 Popups::LOCATION).
  // `id` mirrors that map for readability only - it is never read; `name` is the only field used.
  dialogLocation = [
    { id:1  , name : 'All' },
    { id:2  , name : 'Home' },
    { id:3  , name : 'Deposit' },
    { id:4  , name : 'Withdraw' },
    { id:5  , name : 'Transfer' },
    { id:6  , name : 'Slots-Game' },
    { id:7  , name : 'Casino-Game' },
    { id:8  , name : 'Sports' },
    { id:9  , name : 'Fishing' },
    { id:10 , name : 'Promotion' },
    { id:11 , name : 'Vip' },
    { id:12 , name : 'Contact-Us' },
    { id:13 , name : 'Casino' },
    { id:14 , name : 'Profile' },
    { id:15 , name : 'Esports' },
    { id:16 , name : 'Poker' },
    { id:17 , name : 'Lottery' },
    { id:18 , name : 'Crash-Game' },
    { id:19 , name : 'Table' },
    { id:20 , name : 'About-Us' },
    { id:21 , name : 'Faq' },
    { id:22 , name : 'Terms-Conditions' },
    { id:23 , name : 'Privacy-Policy' },
    { id:24 , name : 'Responsible-Gaming' },
    { id:25 , name : 'Sitemap' }
  ];

  newPromptIncoming: any;
  newVipPromptIncoming: any;
  newManualPromptIncoming: any;
  rewardPrompt: Announcement = null;
  VipDialogPrompt: Announcement = null;
  manualDialogPrompt: Announcement = null;

  whiteListGameLaunchUsernames = ['testuserkent1', 'wtest7', 'btest01', 'liweyiframe', 'xetest01', 'wtestsgen1', 'kwiframe1', 'kwiframe2', 'kwiframe3', 'kwiframe4', 'testmytx', 'pikachu', 'qtptest03', 'pikachubdt', 'pikachumy', 'qtptest', 'pikachubd', 'qtptest1', 'boongo01', 'qtpgsys', 'pgs3mem01', 'pgs3mem02', 'vendortesting', 'restrict01', 'restrict04'];
  whiteListGameLaunchProviders = ['CQ9', 'FC', 'HABA', 'JDB', 'JILI', 'JK', 'KA', 'LIVE', 'MGP', 'PTI', 'VRNL', 'MAX', 'SBO', 'IM', 'IM2', 'TF', 'EVOK', 'SEXY', 'GXW', 'WBET', 'EZ', 'DG', 'BG', 'AB', 'SA', 'SSG', 'WE', 'PGS', 'PGS2', 'YB', 'XE', 'TTG2', 'SIMPLE', 'SG', 'RT2', 'PNG', 'NLC', 'NET2', 'MONKEY', '2BC', 'YL', 'SV388', 'SPRIBE', 'NEX4D', 'MC', 'MAHA', 'LUDO', 'FP', 'EKOR', 'BTG', '365G', 'AMBPOKER', 'AMBSLOT', 'AVI', 'BOOM', 'HSG', 'KM', 'WM', 'CFA88'];

  instantPopupId: Array<number> = [];

  private unsubscribe: Subscription[] = [];
  private pushMessagesListening: boolean = false;
  private pushPermissionOffered: boolean = false;

  constructor(

    private clarityService: ClarityService,
    private newDepositHttpService: NewDepositHttpService,
    private newTwostepDepositDataService: NewTwostepDepositDataService,
    private router: Router,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private deviceDetectorService: DeviceDetectorService,
    private authService: AuthHttpService,
    private eventEmitterService: EventEmitterService,
    private announcementHttpService: AnnouncementHttpService,
    private datePipe: DatePipe,
    private locationHttpService: LocationHttpService,
    private dropdownHttpService: DropdownHttpService,
    private domainService: DomainService,
    private gameCategoryDataService: GameCategoryDataService,
    private emailVerificationHttpService: EmailVerificationHttpService,
    // private os: OneSignalService,
    private seoService: SeoService,
    private seoHttpService: SEOHttpService,
    private renderer: Renderer2,
    private contactListHttpService: ContactListHttpService,
    private promotionContentDataService: PromotionContentDataService,
    private siteHttpService: SiteHttpService,
    public loadingBar: LoadingBarService,
    private walletHttpService: WalletHttpService,
    private bankHttpService: BankHttpService,
    private gameCategoryHttpService: GameCategoryHttpService,
    private merchantBankHttpService: MerchantBankHttpService,
    private bankAccountDataService: BankAccountDataService,
    private liveChatHttpService: LiveChatHttpService,
    private supportChatService: SupportChatService,
    private cdr: ChangeDetectorRef,
    private bonusListWebsocketService: BonusListWebsocketService,
    private transactionStatusUpdateService: TransactionStatusUpdateService,
    public dialog: MatDialog,
    private logoFaviconHttpService: LogoFaviconHttpService,
    private dashboardService: DashboardService,
    private tldService: TldService,
    private sharedService: SharedService,
    private firebaseMessagingService: FirebaseMessagingService,
    private portalMemberProfileHttpService: PortalMemberProfileHttpService,
    private socketIoService: SocketIoService,
    private wssEventSettingService: WSSEventSettingDataService,
    // private websocketService: WebsocketService,
    private http: HttpClient,
    private injector: Injector,
    @Inject(PLATFORM_ID) private platformId: Object,
    ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      this.hostname = (window.location.hostname).replace(/^([w]{3}.)(?=[a-z0-9]+)/, '');
      this.currentCountry = localStorage.getItem('country_code');
      this.siteDomain = JSON.parse(localStorage.getItem('redirect_site_domain'));

      if (environment.production && localStorage.getItem('country_code') === 'SG'){
        document.addEventListener("DOMContentLoaded", () => {
          seoService.setJsonLd();
          seoService.renderer = this.renderer;
        });
      }
    }

    if (this.isBrowser) {
      router.events.subscribe(val => {
        this.authService.getAffiliateAndMarketingParams();
      });

      router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Call popups and marquee API when change page. (Refresh/initial load the page won't call it)
        if (event instanceof NavigationEnd && event.id !== 1 && !window.location.href.includes('/landing') && window.location.pathname !== '/gamelaunch' && window.location.pathname !== '/launch-game') {
          this.onGetAnnouncements();
        }
      });
      tldService.initializeTlds();
    }
  }

  async ngOnInit() {
    if (!this.isBrowser) return;

    this.currentURL = this.router.url.split('/');
    this.supportedCountry = this.dropdownHttpService.availableCountryAndLanguages;
    this.seo = this.dropdownHttpService.seo;
    this.page = this.currentURL[this.currentURL.length - 1] === '' || window.location.pathname == '/' ? 'home' : this.currentURL[this.currentURL.length - 1];
    this.hideAppBase = this.hideAppBaseList.includes(window.location.pathname);
    this.supportedLanguage = this.dropdownHttpService.languages;
    this.newPromptIncoming = this.announcementHttpService.newPromptIncoming;
    this.newVipPromptIncoming = this.announcementHttpService.newVipPromptIncoming;
    this.newManualPromptIncoming = this.announcementHttpService.manualPromptIncoming;

    // Load Microsoft Clarity early so it captures the first page view
    this.loadClarity();

    // Capture affiliate and marketing params early before URL is cleaned
    this.authService.getAffiliateAndMarketingParams();
    
    localStorage.setItem('whitelist_game_launch_usernames', JSON.stringify(this.whiteListGameLaunchUsernames));
    localStorage.setItem('whitelist_game_launch_game_providers', JSON.stringify(this.whiteListGameLaunchProviders));
    console.log('desktop');
    this.newPromptIncoming.subscribe(() => {
      const userData = localStorage.getItem('user_data');
      this.rewardPrompt = AnnouncementHttpService.rewardPrompt;
      if (this.rewardPrompt.updateRewardPrompt == true && JSON.parse(userData).id === this.rewardPrompt.member_account_id) {
        this.eventEmitterService.onUpdateRewardBubble();
        // AIO-83962: pop at assign time regardless of the dialog's Public flag.
        // A Public = OFF dialog broadcasts popUpId = 0, so the instant branch in
        // onSwalFire cannot match it; onGetAnnouncements re-stages it with seen = 0
        // and the seen === 0 branch renders it. This deliberately reverses the
        // AC8/AC9 deferral, for every reward dialog on every brand.
        this.instantPopupId.push(this.rewardPrompt.popUpId);
        this.onGetAnnouncements()
      }
    });

    this.newVipPromptIncoming.subscribe(() => {
      const userData = localStorage.getItem('user_data');
      this.VipDialogPrompt = AnnouncementHttpService.vipDialog;
      // Only act on the event addressed to this member, same as the reward prompt
      // above. The userData guard matters because a client that logged out may
      // still be listening on a socket opened while it was logged in.
      if (userData && this.VipDialogPrompt.updateVipPopup == true
        && JSON.parse(userData).id === this.VipDialogPrompt.member_account_id) {
        this.instantPopupId.push(this.VipDialogPrompt.popUpId);
        // AIO-83962: see the reward handler above - pop at assign time regardless
        // of the dialog's Public flag.
        this.onGetAnnouncements()
      }
    });

    this.newManualPromptIncoming.subscribe(() => {
      const userData = localStorage.getItem('user_data');
      this.manualDialogPrompt = AnnouncementHttpService.manualPrompt;
      if (userData && this.manualDialogPrompt.updateManualPrompt == true
        && JSON.parse(userData).id === this.manualDialogPrompt.member_account_id) {
        this.instantPopupId.push(this.manualDialogPrompt.popUpId);
        if (this.manualDialogPrompt.popUpId > 0) {
          this.onGetAnnouncements()
        }
      }
    });
    
    // FOR VERSION LOGIC
    this.storageForVersion();
    // 5mins
    interval(5 * 60 * 1000).subscribe(
      () => {
        this.checkVersionNew();
      }
    );

    this.route.queryParams.subscribe((params: Params) => {
      this.username = params['username'];
      this.password = params['password'];

      if (this.username && this.password) {
        sessionStorage.setItem('initialLogin', '1');
        this.loadingBar.start();
        this.authService.login(this.username, this.password).pipe(
          tap(async (res: any) => {
            this.store.dispatch(Login(res.data.token));
            localStorage.setItem('verified_number', res.data.user.phone_validated);
            if (res.data.user.name !== '') {
              this.walletHttpService.getMemberBalance().subscribe(wallet => {
                if (wallet.balance <= 0) {
                  this.eventEmitterService.onAvailableProviderEmitter();
                }
                of(null).pipe(
                  delay(1000), tap(() => this.eventEmitterService.onTopBarTabEmitter()
                  )).subscribe();
                localStorage.setItem('profile', res.data.user.name);
              });
            }
            this.setSessionStorage(res.data.user.country_code);
            // Match the page segment after the /:locale prefix (segment 1), not a bare substring,
            // so slugs like /promotion/mega-slots-bonus don't falsely trigger these refreshes.
            const currentPage = window.location.pathname.split('/').filter(Boolean)[1]?.toLowerCase() ?? '';
            if (currentPage === 'slots' || currentPage === 'slots-game') {
              this.eventEmitterService.onUpdateSlots();
            }
            if (currentPage === 'fishing') {
              this.eventEmitterService.onUpdateFishing();
            }
            if (currentPage === 'table') {
              this.eventEmitterService.onUpdateTable();
            }
            if (res.data.user.country_code !== 'ID') {
              if ((window.location.pathname.split('/').filter(Boolean)[1] ?? '').toLowerCase() === 'poker') {
                this.router.navigateByUrl('/');
              }
            }
            this.loadingBar.complete();
            //this.disableButton = false;
            this.eventEmitterService.footerPaddingEmiter.emit(500);

            await this.getPromotion();

            if (res.data.user.country_code !== this.currentCountry) {
              window.location.reload();
            }
            // Set livechat name and email after login
            if (localStorage.getItem('user_data') != null) {
              let username = JSON.parse(localStorage.getItem('user_data')).username;
              let email = JSON.parse(localStorage.getItem('user_data')).email;

              if (username != null && username !== '') {
                if (this.siteHttpService.live_chat_platform_name == 'Live Chat') {
                  window.LiveChatWidget.call("set_customer_name", username);
                } else if (this.siteHttpService.live_chat_platform_name == 'Crisp') {
                  Crisp.user.setNickname(username);
                }
              }
              if (email != null && email !== '') {
                if (this.siteHttpService.live_chat_platform_name == 'Live Chat') {
                  window.LiveChatWidget.call("set_customer_email", email);
                } else if (this.siteHttpService.live_chat_platform_name == 'Crisp') {
                  Crisp.user.setEmail(email);
                }
              }
            }

          }),
          finalize(() => {
            localStorage.removeItem('announcements_pop');
            this.router.navigate(['/']);
          })
        ).subscribe();
      }
    })

    // If is external launch game (launch game from other site)
    let params: any = this.authService.getUrlParams(window.location.search);
    let externalLaunch = params['externalLaunch'];

    if (externalLaunch && externalLaunch == '1') {
      localStorage.removeItem('gameCategory');
      localStorage.removeItem('gameCode');
      localStorage.removeItem('gameProviderId');
      localStorage.removeItem('gameProviderCode');
      localStorage.removeItem('isPlayTechClicked');
      localStorage.removeItem('gameType');
      localStorage.removeItem('gameMode');
      localStorage.removeItem('gameDemo');
      localStorage.removeItem('subCategoryCode');

      // let decryptedParams = this.siteHttpService.decrypt(externalLaunch);
      const userData = params['userData'];
      const userToken = params['accessToken'];

      if (userData && userToken) {
        let user = JSON.parse(userData);
        localStorage.setItem('country_code', user['country_code']);
        localStorage.setItem('user_data', userData);
        localStorage.setItem('user_token', userToken);
      }

      if (params['gameProviderCode']) localStorage.setItem('gameProviderCode', params['gameProviderCode']);
      if (params['gameCategory']) localStorage.setItem('gameCategory', params['gameCategory']);
      if (params['isPlayTechClicked']) localStorage.setItem('isPlayTechClicked', params['isPlayTechClicked']);
      if (params['gameProviderId']) localStorage.setItem('gameProviderId', params['gameProviderId']);
      if (params['gameCode']) localStorage.setItem('gameCode', params['gameCode']);
      if (params['gameType']) localStorage.setItem('gameType', params['gameType']);
      if (params['gameMode']) localStorage.setItem('gameMode', params['gameMode']);
      if (params['gameDemo']) localStorage.setItem('gameDemo', params['gameDemo']);
      if (params['subCategoryCode']) localStorage.setItem('subCateoryCode', params['subCategoryCode']);
      if (params['gamelaunchGameMode']) localStorage.setItem('gameMode', params['gamelaunchGameMode']);
      if (params['countryCode']) localStorage.setItem('country_code', params['countryCode']);
    }
    
    this.continueOTPCounter();

    if (window.location.pathname !== '/unsupported-country') {
      this.isLoggedIn$ = this.store.pipe(select(IsLoggedIn));
      this.pathName = window.location.pathname;
      this.removePopUp();
      this.getHostname();
      
      // triger pop announcement when login.
      this.eventEmitterService.updateCountryAndLanguageEmitter.subscribe(() => {
        // localStorage.removeItem('announcements_pop');
        this.getLiveChatScript();
        this.onGetAnnouncements();
        this.getContactUs();  
        this.logoFaviconHttpService.updateLogoAndFavicon();
        this.getMiniGameScript();
      })

      // Grab and update click count whenever affiliate
      // or marketing campaign param is present from URL
      this.route.queryParams.subscribe(async (params: Params) => {
        const loginToken = params['loginToken'];
        this.campaignCode = params[`campaign`];
        this.affiliateCode = params[`aff`];
        this.affiliateCampaignCode = params[`affcampaign`];
        if (this.campaignCode) {
          this.authService.updateCampaignClickCount(this.campaignCode).subscribe();
        }
        if (this.affiliateCode) {
          this.authService.updateAffiliateClickCount(this.affiliateCode).subscribe();
        }
        if ((this.affiliateCampaignCode && this.affiliateCode)) {
          this.authService.updateAffiliateCampaignClickCount(this.affiliateCampaignCode, this.affiliateCode).subscribe();
        }
        
        if (loginToken) {
          this.http.get(`/cross-login/consume?token=${loginToken}`).subscribe((res: any) => {
            localStorage.setItem('user_data', JSON.stringify(res.userData));
            localStorage.setItem('user_token', res.userToken);

            // set defaults
            localStorage.setItem('country_code', res.userData.country_code);
            localStorage.setItem('language_code', res.userData.lang_code);

            if (res.authSuffix.rewardNotice !== undefined)
              localStorage.setItem('reward_notice', res.authSuffix.rewardNotice);
            
            if (res.authSuffix.isShowDemoNotice !== undefined)
              localStorage.setItem('isShowDemoNotice', res.authSuffix.isShowDemoNotice);

            if (res.authSuffix.verifiedNumber !== undefined)
              localStorage.setItem('verified_number', res.authSuffix.verifiedNumber);

            if( window.location.pathname !== '/gamelaunch' && window.location.pathname !== '/launch-game') this.bonusListWebsocketService.listenGetBonusListEvent();
            if( window.location.pathname !== '/gamelaunch' && window.location.pathname !== '/launch-game') this.transactionStatusUpdateService.listenTransactionUpdateEvent();
            
            window.location = window.location.href.split("?")[0];
          }, err => {
            console.error('Cross-login token invalid or expired', err);
            // Optional: redirect to login page
          });
        }

        if (localStorage.getItem("bonus") == null && localStorage.getItem('user_data') !== null && localStorage.getItem('user_token') !== null) {
          await this.getPromotion();
          //generate gtag
          this.eventEmitterService.onGtagEmitter();
          //set mini game widget
          this.eventEmitterService.onUpdateWidget();
          //update mobile domain
          this.eventEmitterService.onUpdateMobileDomain();

          // Set livechat name and email after login
          if (localStorage.getItem('user_data') != null) {
            let username = JSON.parse(localStorage.getItem('user_data')).username;
            let email = JSON.parse(localStorage.getItem('user_data')).email;
            
            if (username != null && username !== '') {
              if (this.siteHttpService.live_chat_platform_name == 'Live Chat') {
                window.LiveChatWidget.call("set_customer_name", username);
              } else if (this.siteHttpService.live_chat_platform_name == 'Crisp') {
                Crisp.user.setNickname(username);
              }
            }
            if (email != null && email !== '') {
              if (this.siteHttpService.live_chat_platform_name == 'Live Chat') {
                window.LiveChatWidget.call("set_customer_email", email);
              } else if (this.siteHttpService.live_chat_platform_name == 'Crisp') {
                Crisp.user.setEmail(email);
              }
            } 
          }

          this.eventEmitterService.onCountryCode();
        }
      });

      this.isLoggedIn$.subscribe(async res => {
        if(res) {
          // this.os.onInit();
          
          this.startPushNotifications();

          // Initial check from session storage or API
          this.wssEventSettingService.getCachedWssStatus('member-online').subscribe((isActive) => {
            if (isActive) {
              this.socketIoService.join('member-online');
            }
          });

           // Always start listening for WSS status changes
          this.listenToWssEventSettingChanges();
       
          if (window.location.pathname !== '/gamelaunch') {
            this.transactionStatusUpdateService.listenTransactionUpdateEvent();
          }

          this.listenToForceLogoutEvents();
          this.checkPendingPaymentTwostepDeposit();
        }
      });

      this.siteHttpService.getSiteDomain().subscribe(res => {
        localStorage.removeItem(this.siteDomain)
        localStorage.setItem('redirect_site_domain', JSON.stringify(res))
        const landing_page_domain = res.find(x => x.type == 2);
        const game_launch_domain = res.find(x => x.type == 3);
        if (game_launch_domain && window.location.href.includes(game_launch_domain['domain'])) {
          if (!(window.location.href.includes('/gamelaunch?externalLaunch'))) {
            let url = ((environment.https ? 'https://' : '//') + landing_page_domain['domain']);
            window.location.replace(url);
          }
        }
        this.landingPage();
      })

      this.onVerifyEmail();
      this.browserInit();

      if (window.location.pathname !== '/gamelaunch' && window.location.pathname !== '/launch-game') this.getLiveChatScript();
      if (window.location.pathname !== '/gamelaunch' && window.location.pathname !== '/launch-game') this.getContactUs();

      // Set timeout to prevent get null value for localStorage variable
      setTimeout(() => {
        this.checkLocation();
        this.getAllGameProvider();
      }, 1000)

      // Path is the source of truth for language — derive it from the /:locale/ URL segment,
      // falling back to localStorage only when the path has no locale.
      const pathLocaleMatch = window.location.pathname.match(/^\/([a-zA-Z]{2})-[a-zA-Z]{2}(?:\/|$)/);
      const languageCode = pathLocaleMatch ? pathLocaleMatch[1] : localStorage.getItem('language_code');
      const userLocale = localStorage.getItem('user_locale');
      if (languageCode !== null) {
        this.translateService.use((languageCode).toLocaleLowerCase());
      }
      else {
        if (userLocale != null && this.supportedLanguage[userLocale.toUpperCase()] !== undefined) {
          this.translateService.use((userLocale).toLocaleLowerCase());
        };
      }
      /** START : Code to Track Page View using gtag.js */
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
      ).subscribe((event: NavigationEnd) => {
        // gtag('event', 'page_view', {
        //   page_path: event.urlAfterRedirects
        // });
        /** END : Code to Track Page View  using gtag.js */
        /** AIO-81499: Clarity rotates its own sessions independently of the SPA, so a
         *  session opened mid-visit inherits no tags unless they are re-stamped. */
        this.clarityService.syncIdentity();
        this.clarityService.reapplyToNewSession();
        this.getRouteTitle(this.activatedRoute).data
          .pipe(tap(data => {
            // Prefer explicit `title`, fall back to `routeName` (qply routes define routeName,
            // whose values match template-02's title values e.g. 'Fishing', 'Slots', 'Casino').
            // Drives the browser tab as "<Page> | <siteName>" and the provider-page SEO check below.
            this.pageTitle = data['title'] || data['routeName'];
            this.updateSeoFooter();
            this.eventEmitterService.footerPaddingEmiter.emit(500);
          })).subscribe(() => {
            this.titleService.setTitle((this.pageTitle ? this.pageTitle + ' | ' : '') + this.siteName);
            /* BO SEO settings override the route title and metatags, so run after setTitle */
            this.seoHttpService.updateSEO();
            this.seoService.execute();
          });
      });
      // Update the meta tags when: language is changed | finish loading the translation files
      // const metaTag = this.translateService.onTranslationChange.subscribe(() => this.seoService.execute({ hardReset: true }));
      // const metaTag2 = this.translateService.onLangChange.subscribe(() => this.seoService.execute({ hardReset: true }));
      // this.unsubscribe.push(metaTag, metaTag2);

      const userData = localStorage.getItem('user_data');
      const userToken = localStorage.getItem('user_token');
      if (userData && userToken) {
        let user = JSON.parse(userData);
        localStorage.setItem('country_code', user['country_code']);
        const parsedToken = JSON.parse(userToken);
        this.store.dispatch(Login({ access_token: parsedToken.access_token, plaintext_token: parsedToken.plaintext_token }));
      }

      this.eventEmitterService.metaTagDefault.subscribe(() => {
        this.titleService.setTitle((this.pageTitle ? this.pageTitle + ' | ' : '') + this.siteName);
      })
      if (window.location.pathname !== '/gamelaunch' && window.location.pathname !== '/launch-game') {
        this.eventEmitterService.resetAnnouncementVar = this.eventEmitterService.resetAnnouncementEmitter.subscribe(() => {
          this.onGetAnnouncements();
        });
      }

      if (this.maintenanceDateTime === null && !window.location.href.includes('/landing') && window.location.pathname !== '/gamelaunch' && window.location.pathname !== '/launch-game') {
        this.onGetAnnouncements();
      }

      //when login or claim reward
      this.eventEmitterService.updateWidgetEmitter.subscribe(() => {
        this.setWidget();
      });

      //when change page
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.checkVersionNew();
          //this.previousRoute == undefined, check for reload
          if (this.CloseWidgetCounter > 0 || this.previousRoute == undefined) {
            //only login user will set minigame widget
            const userData = localStorage.getItem('user_data');
            const userToken = localStorage.getItem('user_token');
            if (userData && userToken) {
              this.setWidget();
              //reset counter
              this.CloseWidgetCounter = 0;
            }
          }
          this.previousRoute = event.url;
        }
      });

      this.redirectToS3Link();
    }

    this.onCheckConnection();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkForDialogParam();
      }
    });

    this.isLoggedIn$.subscribe(res => {
      this.onGetAnnouncements();
    });

    this.prefetchMarqueeAndMaintenanceToStorage();
  }

  ngOnDestroy() {
    if (!this.isBrowser) return;
    if (this.unsubscribeForceLogout) {
      this.unsubscribeForceLogout();
      const accessToken = JSON.parse(localStorage.getItem('user_token') || '{}')?.access_token;
      if (accessToken) {
        this.socketIoService.leave(`force-logout-channel_${accessToken}`);
      }
    }
    this.unsubscribe.map(sb => sb.unsubscribe);
    this.connectionSubscription.unsubscribe();
  }

  onSwalFire(page?: string, announcementPop?: any) {

    var currentURL = window.location.pathname.split('/');
    let Current_page = 'home';
    if (currentURL && this.currentURL.length > 1) {
      const result = currentURL.find((value: any) => this.dialogLocation.some(item => item.name.toLowerCase() === value.toLowerCase())) || 'home';
      // The /casino route IS the Casino-Game page, but api2 only ever names that
      // location 'casino-game' (Popups::LOCATION[7]). Current_page holds the raw URL
      // segment, so map it onto the backend name - otherwise a Casino-Game dialog
      // can never match on /casino and only 'all' dialogs show there.
      Current_page = (result === 'casino') ? 'casino-game' : result;
    }
    this.announcements$ = [];
    this.announcementIds = [];

    if (announcementPop !== undefined) {
      localStorage.removeItem('popup_ids');
      JSON.parse(announcementPop).map((announcement: any) => {
        if ((announcement.location_name === Current_page || announcement.location_name === 'all') && Current_page !== 'landing' && window.location.pathname !== 'gamelaunch' && this.instantPopupId.length > 0 && this.instantPopupId.includes(announcement.id)) {
          if (Array.isArray(announcement.content) && announcement.content.length > 0) {
            announcement.content[0] = {
              ...announcement.content[0],
              do_not_show_again: announcement.do_not_show_again
            };
          }
          this.announcements$.push(announcement.content);
          this.announcementIds.push(announcement.id);
        }
        else if ((announcement.location_name === Current_page || announcement.location_name === 'all') && announcement.seen === 0 && Current_page !== 'landing' && window.location.pathname !== 'gamelaunch') {
          if (Array.isArray(announcement.content) && announcement.content.length > 0) {
            announcement.content[0] = {
              ...announcement.content[0], 
              do_not_show_again: announcement.do_not_show_again
            };
          }
          this.announcements$.push(announcement.content);
          this.announcementIds.push(announcement.id);
        }
      });
      this.instantPopupId = [];
      this.cdr.markForCheck();
      localStorage.setItem('popup_ids', JSON.stringify(this.announcementIds));
      this.eventEmitterService.onSwalAnnouncementEmitter(Current_page);

      // Every announcement already seen / not for this page: no popup renders, so `confirmed`
      // never fires and the insufficient-funds probe in onUpdateAnnouncement would be skipped.
      // Once per page load and only when logged in: onGetAnnouncements runs on every navigation,
      // and each probe is a /wallet/allbalance call that also queries the game providers.
      if (this.announcements$.length === 0 && !this.seenAnnouncementsProbed && localStorage.getItem('user_data') != null) {
        this.seenAnnouncementsProbed = true;
        this.onUpdateAnnouncement();
      }
    }
  }

  onUpdateAnnouncement() {
    if (localStorage.getItem('announcements_pop') !== null) {
      let isSeen = 0;
      const announcementPop: any[] = [];
      JSON.parse(localStorage.getItem('announcements_pop')).map((announcement: any) => {
        announcementPop.push({
            ...announcement,
            seen:  this.announcementIds.findIndex(x => x === announcement.id) !== -1  ? 1 : announcement.seen
          });
        localStorage.setItem('announcements_pop', JSON.stringify(announcementPop));
      });

      localStorage.setItem('announcements_pop', JSON.stringify(announcementPop));
    }

    localStorage.setItem('announcements_pop_available','0');
    if (localStorage.getItem('user_data') && localStorage.getItem('user_data') != null) {
      this.onRefreshBalance();
      // if (localStorage.getItem('reward_notice') == '1' && localStorage.getItem('announcements_pop_available') == '0') {
      //   this.onRewardNotice();
      // }else{
      //   this.onRefreshBalance();
      // }
    } else {
      // `user_data` is written by the `legacySessionKeys` meta-reducer on login, which can
      // land AFTER this runs (modal-login race). A one-shot check sees null and the
      // insufficient-funds probe is then skipped for the whole session. Mobile polls for it;
      // mirror that here, bounded (~15s) so the interval can never leak.
      let tries = 0;
      const checkInterval = setInterval(() => {
        if (localStorage.getItem('user_data') && localStorage.getItem('user_data') != null) {
          clearInterval(checkInterval);
          this.onRefreshBalance();
        } else if (++tries >= 30) {
          clearInterval(checkInterval);
        }
      }, 500);
    }
  }

  show() {
    if (this.isShowFooter == false) {
      this.footerWait();
    }
    
    // Landing now lives at '/' (path '' → LandingComponent); also cover legacy '/landing'
    // and /thank-you (PG returns with querystring, e.g. /thank-you?status=success).
    const pathOnly = this.router.url.split('?')[0];
    if (pathOnly === '/' || pathOnly === '/landing' || pathOnly === '/thank-you' || this.router.url.includes('thank-you')) {
      return false;
    } else {
      return true;
    }
  }

  footerWait() {
    setTimeout(() => {
      this.isShowFooter = true;
    }, 1500)

  }
  // Remove query params from the address bar without disturbing the ones we keep.
  // URLSearchParams/URL.toString() re-serialises the whole query string and turns
  // a kept %20 into '+', which getUrlParams()'s decodeURIComponent does not turn
  // back into a space - so any marketing value with a space would be corrupted.
  private hideUrlParams(keys: string[]) {
    const query = window.location.search.replace(/^\?/, '').split('&')
      .filter((pair: string) => pair !== '' && !keys.includes(pair.split('=')[0]))
      .join('&');
    window.history.replaceState({}, '',
      window.location.pathname + (query ? '?' + query : '') + window.location.hash);
  }

  onGetAnnouncements() {
    // Popups must never appear on the landing / country-language page. Landing now lives at
    // '/'; the per-call-site guards only tested the legacy '/landing' string and missed the
    // root '/', so a dialog leaked onto the landing page. Gate the fetch here for every caller.
    if (this.isNoPopupRoute) return;

    const dateToday = this.datePipe.transform(this.todayDate, 'yyyy-MM-dd');

    if (localStorage.getItem('date_today') !== dateToday) {
      localStorage.setItem('date_today', dateToday);
      localStorage.removeItem('announcements_pop');
      localStorage.removeItem('marquees');
    }

    this.route.queryParams.subscribe(async (params: Params) => {
      let dialogCode = null;
      if ((params['campaign'] != undefined || params['access_token'] != undefined) && params['dialog']) {
        localStorage.setItem('dialog', params['dialog']);
        // Hide the marketing params from the address bar.
        this.hideUrlParams(['campaign', 'dialog']);
      }
      else if (params['campaign'] == undefined && params['access_token'] == undefined && params['dialog']) {
        dialogCode = params['dialog']
        localStorage.setItem('dialog', params['dialog']);
        this.hideUrlParams(['dialog']);
      }
      else if (params['campaign'] == undefined && params['access_token'] == undefined && params['dialog'] == undefined) {
        dialogCode = localStorage.getItem('dialog');
      }

      this.announcementSubscription.unsubscribe();
      this.announcementSubscription = this.announcementHttpService.getPopUp(dialogCode).subscribe(res => {
        if (dialogCode == null) {
          let announcementPopList = JSON.parse(localStorage.getItem('announcements_pop'));
          let announcementPopCodes = res.map(function(i: any) {
            return i['code'];
          });
          if (announcementPopCodes.length > 0 && announcementPopList != null) {
            announcementPopList = announcementPopList.filter((x: any) => announcementPopCodes.includes(x.code));
            localStorage.setItem('announcements_pop', JSON.stringify(announcementPopList));
          }
        }

        const announcementPop: any = [];
        res.map((announcement: any) => {
          if (res.length > 0) {
            announcement.content[0].session = announcement.session;
            // announcement.platform : 1 = All , 2 == Mobile , 3 == Desktop
            if(announcement.platform == 1 || announcement.platform == 3){ 
              if(localStorage.getItem('user_data') != null){
                // announcement.session :  1 = All , 2 == Before login , 3 == after login
                if (announcement.session == 1 || announcement.session == 3) {
                  let seenStatus = 0;
                  if (localStorage.getItem('announcements_pop') !== undefined && localStorage.getItem('announcements_pop') !== null) {
                    let announcementList = JSON.parse(localStorage.getItem('announcements_pop'))
                    let announcementListFilter = announcementList.filter((x: any) => x.id == announcement.id)
                    if (announcementListFilter.length >0) {
                      if (announcementListFilter[0].always_pop == 0 || announcement.assigned_unseen) {
                        announcementList = announcementList.filter((x: any) => x.id != announcement.id)
                        localStorage.setItem('announcements_pop', JSON.stringify(announcementList))
                      } else {
                        seenStatus = announcementListFilter[0].seen == 1 ? 1 : 0;
                      }
                    }
                  } 
                  announcementPop.push({
                    content: announcement.content,
                    id: announcement.id,
                    code: announcement.code,
                    location_name: announcement.location_name,
                    seen: seenStatus,
                    settings_locale_id: announcement.settings_locale_id,
                    always_pop: announcement.always_pop,
                    do_not_show_again: announcement.do_not_show_again,
                  });
                }
              }else{
                if (announcement.session == 1 || announcement.session == 2) {
                  let seenStatus = 0;
                  if (localStorage.getItem('announcements_pop') !== undefined && localStorage.getItem('announcements_pop') !== null) {
                    let announcementList = JSON.parse(localStorage.getItem('announcements_pop'))
                    let announcementListFilter = announcementList.filter((x: any) => x.id == announcement.id)
                    if (announcementListFilter.length >0) {
                      if (announcementListFilter[0].always_pop == 0) {
                        announcementList = announcementList.filter((x: any) => x.id != announcement.id)
                        localStorage.setItem('announcements_pop', JSON.stringify(announcementList))
                      } else {
                        seenStatus = announcementListFilter[0].seen == 1 ? 1 : 0;
                      }
                    }
                  } 
                  announcementPop.push({
                    content: announcement.content,
                    id: announcement.id,
                    code: announcement.code,
                    location_name: announcement.location_name,
                    seen: seenStatus,
                    settings_locale_id: announcement.settings_locale_id,
                    always_pop: announcement.always_pop,
                    do_not_show_again: announcement.do_not_show_again,
                  });
                }
              }
            }
          }
        });

        if (announcementPop.length > 0) {
          const popUpAnnouncementsFromLocal = localStorage.getItem('announcements_pop');
          if (popUpAnnouncementsFromLocal === null || JSON.parse(popUpAnnouncementsFromLocal).length === 0) {
            if (dialogCode) {
              announcementPop.forEach(function (item: any, i: any) {
                if (item['code'] == dialogCode) {
                  announcementPop.splice(i, 1);
                  announcementPop.unshift(item);
                }
              });
            }
            localStorage.setItem('announcements_pop', JSON.stringify(announcementPop));
            this.eventEmitterService.onSwalAnnouncementEmitter(this.page);
            this.onSwalFire(this.page ,JSON.stringify(announcementPop));
          } else {
            if (JSON.stringify(announcementPop) !== JSON.stringify(this.setOldAnnouncements(popUpAnnouncementsFromLocal))) { // if the announcement list update on BO this would update the list on storage
              const updatedPopUpAnnouncements = this.mergeAllAnnouncements(announcementPop.concat(JSON.parse(popUpAnnouncementsFromLocal)));
              const finalPopUpAnnouncement = this.setFinalAnnouncement(updatedPopUpAnnouncements);
              if (dialogCode) {
                finalPopUpAnnouncement.forEach(function (item, i) {
                  if (item['code'] == dialogCode) {
                    finalPopUpAnnouncement.splice(i, 1);
                    finalPopUpAnnouncement.unshift(item);
                  }
                });
              }
              localStorage.setItem('announcements_pop', JSON.stringify(finalPopUpAnnouncement));
              this.onSwalFire(this.page,  JSON.stringify(finalPopUpAnnouncement));
            }else{
              this.onSwalFire(this.page ,popUpAnnouncementsFromLocal);
            }
          }
        } else {
          this.onUpdateAnnouncement();
          localStorage.removeItem('announcements_pop');
        }
      });
    });

    const marqueeslist: { contents: Marquees['contents']; id: number; position: number }[] = [];
    this.announcementHttpService.getMarquees().subscribe(res => {
      res.map((marquees: any) => {
        if (res.length > 0) {
          // here is the login marquees
          if(localStorage.getItem('user_data') != null){
            if (marquees.session == 1 || marquees.session == 3) {
              marqueeslist.push({
                contents: marquees.contents,
                id: marquees.id,
                position: marquees.position
              });
            }
          }else{
            if (marquees.session == 1 || marquees.session == 2) {
              marqueeslist.push({
                contents: marquees.contents,
                id: marquees.id,
                position: marquees.position
              });
            }
          }
        }
      });

      if (marqueeslist.length > 0) {
        const marqueesFromLocal = localStorage.getItem('marquees');
        if (marqueesFromLocal === null || JSON.parse(marqueesFromLocal).length === 0) {
          localStorage.setItem('marquees', JSON.stringify(marqueeslist));
        } else {
          if (JSON.stringify(marqueeslist) !== JSON.stringify(JSON.parse(marqueesFromLocal))) { // if the announcement list update on BO this would update the list on storage
            localStorage.setItem('marquees', JSON.stringify(marqueeslist));
          }
        }
      } else {
        localStorage.removeItem('marquees');
      }

      this.eventEmitterService.onMarqueesEmitter();
    });
  }

  setCloseWidgetCounter(event: any) {
    this.CloseWidgetCounter = event;
  }

  async onCheckConnection() {
    if (!this.isBrowser) return;
    const { ConnectionService } = await import('ng-connection-service');
    const connectionService = this.injector.get(ConnectionService);
    this.connectionSubscription.add(
      connectionService.monitor().pipe(
        tap((newState: ConnectionState) => {
          this.connectionState = newState;
          if (!this.connectionState.hasNetworkConnection) {
            this.dialog.open(PopupServiceWorkerComponent, { width: '800px', data: { type: 'connection-err' } });
          } else {
            this.dialog.closeAll();
          }
        })
      ).subscribe()
    );
  }

  private checkVersionNew() {
    const url = `${window.location.origin}/version.json?v=${new Date().getTime()}`;

    fetch(url)
      .then(response => response.json())
      .then((data: any) => {
        const currentVersion = localStorage.getItem('version');
        const latestVersion = data.hash;

        const wasReloadedOrJustVisit = sessionStorage.getItem('wasReloadedOrJustVisit');
        if (wasReloadedOrJustVisit || currentVersion == null) {
          localStorage.setItem('version', latestVersion);
          sessionStorage.removeItem('wasReloadedOrJustVisit');
        }else{
          if(currentVersion != null && currentVersion != latestVersion){
            this.sharedService.setVersionStatus(latestVersion); // Notify TopbarComponent
          }
        }
      })
      .catch(err => {
        console.error('Could not get version:', err);
      });
  }

  private storageForVersion(){
    const loggedOut = sessionStorage.getItem('loggedOut');
    if(loggedOut){
      sessionStorage.removeItem('loggedOut');
    }else{
      sessionStorage.setItem('wasReloadedOrJustVisit', 'true');
    }
  }

  private getContactUs() {
    this.contactListHttpService.getContactList().subscribe(res => {
      sessionStorage.setItem('contact_us', JSON.stringify(res))
      this.eventEmitterService.onUpdateContactUs();
    });
  }

  private updateSeoFooter() {
    const providerPages = ['Slots', 'Casino', 'Sports', 'Esports'];
    if (!providerPages.includes(this.pageTitle)) {
      if (window.location.pathname === '/') {
        this.eventEmitterService.onUpdateSeoFooter('main');
      } else {
        this.eventEmitterService.onUpdateSeoFooter('');
      }
    }
  }

  private onVerifyEmail() {
    if (window.location.pathname === '/verify-email') {
      if (window.location.search === '') {
        this.router.navigate(['/']);
      } else {
        if (window.location.search.split('?token=')[1] === '') {
          this.router.navigate(['/']);
        } else {
          this.emailVerificationHttpService.verify({ token: window.location.search.split('?token=')[1] }).pipe(
            tap((res: any) => {
              localStorage.setItem('verify_email_message', JSON.stringify(res));
              this.afterOnVerification();
            })
          ).subscribe();
        }
      }
    }
  }

  private setFinalAnnouncement(updatedPopUpAnnouncements: any) { // set the final announcement before push to localstorage
    const finalPopUp: any[] = [];
    updatedPopUpAnnouncements.map((result: any) => {
      finalPopUp.push({
        ...result,
        content: result.content[0],
        location_name: result.location_name[0],
        seen: (result.settings_locale_id[0] !== result.settings_locale_id[1] || result.location_name[0] !== result.location_name[1]
          || JSON.stringify(result.content[0][0]) !== JSON.stringify(result.content[1])) && (result.seen[0] !== result.seen[1]) ? result.seen[0] : result.seen[1],
        settings_locale_id: result.settings_locale_id[0]
      });
    });
    return finalPopUp;
  }

  private setOldAnnouncements(announcements: any) { // update localstorage seen to 0
    const popUp: any[] = [];
    JSON.parse(announcements).map((res: any) => {
      popUp.push({
        ...res,
        seen: 0
      });
    });
    return popUp;
  }

  private mergeAllAnnouncements(allAnnouncement: any) { // merge all data but unique id
    const updatedPopUpAnnouncements: any[] = [];
    allAnnouncement.map((allAnn: any) => {
      const existing = updatedPopUpAnnouncements.filter((v, i) => {
        return v.id === allAnn.id;
      });
      if (existing.length) {
        const existingIndex = updatedPopUpAnnouncements.indexOf(existing[0]);
        updatedPopUpAnnouncements[existingIndex].content = updatedPopUpAnnouncements[existingIndex].content.concat(allAnn.content);
        updatedPopUpAnnouncements[existingIndex].location_name = updatedPopUpAnnouncements[existingIndex].location_name.concat(allAnn.location_name);
        updatedPopUpAnnouncements[existingIndex].seen = updatedPopUpAnnouncements[existingIndex].seen.concat(allAnn.seen);
        updatedPopUpAnnouncements[existingIndex].settings_locale_id = updatedPopUpAnnouncements[existingIndex].settings_locale_id.concat(allAnn.settings_locale_id);
      } else {
        allAnn.content = [allAnn.content];
        allAnn.location_name = [allAnn.location_name];
        allAnn.seen = [allAnn.seen];
        allAnn.settings_locale_id = [allAnn.settings_locale_id];
        updatedPopUpAnnouncements.push(allAnn);
      }
    });
    return updatedPopUpAnnouncements;
  }

  private browserInit() {
    if (this.deviceDetectorService.isMobile()) {
      let mobilePreExt = null;
      let fullDomain = '';

      // Get the mobile pre extension for the country
      Object.keys(this.supportedCountry[this.currentDomain]).forEach(key => {
        if (this.supportedCountry[this.currentDomain][key][environment.domainEnv].includes(this.hostname)) {
          mobilePreExt = this.supportedCountry[this.currentDomain][key].mobilePreExt;
        }
      })

      // Append full domain
      if (mobilePreExt === null || environment.domainEnv == 'demo' || environment.domainEnv == 'staging') {
        fullDomain = (environment.https ? 'https://' : '//') + environment.mobileDomainName;
      } else {
        fullDomain = (environment.https ? 'https://' : '//') + mobilePreExt + this.hostname;
      }
      this.isMobileDetected = true;
      const marketingParams: any = this.authService.getUrlParams(window.location.search);
      let authSuffix = '';
      if (Object.keys(marketingParams)) {
        authSuffix = `${(window.location.pathname)}?${Object.keys(marketingParams).map(key => key + '=' + marketingParams[key]).join('&')}`;
      }
      // Begin:: Cross device login
      if (localStorage.getItem('user_token') && localStorage.getItem('user_data')) {
        const payload = {
          userToken: JSON.parse(localStorage.getItem('user_token')!),
          userData: JSON.parse(localStorage.getItem('user_data')!),
          authSuffix: marketingParams
        };

        this.http.post('/cross-login/generate', payload).subscribe((res: any) => {
          // Redirect mobile with short token
          window.location.href = `${fullDomain}?loginToken=${res.token}`;
        });
      }else{
        // End:: Cross device login
        window.location.href = fullDomain + authSuffix;
      }
    }
  }

  private getRouteTitle(activatedRoute: ActivatedRoute): ActivatedRoute {
    if (activatedRoute.firstChild) {
      return this.getRouteTitle(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  private removePopUp() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.get('lang') !== null) {
      const languageAndCountry = urlParams.get('lang').split('_');
      if (!languageAndCountry[1].includes('https://')) {
        if (localStorage.getItem('country_code') !== languageAndCountry[1]) {
          localStorage.removeItem('announcements_pop')
        }
      }
    }
  }

  // This function is to check whether should navigate to landing page else set country&language code to localStorage
  private landingPage() {
    let countryCode = localStorage.getItem('country_code') ? localStorage.getItem('country_code') : null;
    let languageCode = localStorage.getItem('language_code') ? localStorage.getItem('language_code') : null;

    Object.keys(this.supportedCountry[this.currentDomain]).forEach(key => {

      console.log("this.supportedCountry : ", this.supportedCountry);
      console.log("this.currentDomain : ", this.currentDomain);
      console.log("key : ", key);
      console.log("environment.domainEnv : ", environment.domainEnv);

      if (this.supportedCountry[this.currentDomain][key][environment.domainEnv].includes(this.hostname)) {
        countryCode = key;
      }
    });

    const urlParams = new URLSearchParams(window.location.search);
    // If got param, this param is pass from landing page
    if (urlParams.get('lang') !== null && localStorage.getItem('user_data') == null) {
      // Eg. MY_EN
      const countryAndLanguage = urlParams.get('lang').split('_');
      localStorage.setItem('country_code', countryAndLanguage[0]);
      localStorage.setItem('language_code', countryAndLanguage[1]);
      this.translateService.use(countryAndLanguage[1].toLocaleLowerCase());
    }
    // No param
    else {
      // Production
      if (environment.production) {
        localStorage.getItem('country_code') === null ? localStorage.setItem('country_code', countryCode) : '';   // Set to default value if null
        let language_code = countryCode === 'ID' ? 'ID' : (countryCode === 'TH' ? 'TH' : 'EN'); // EN by default for all country except for Indonesia & Thailand

        // If BD or CN, use default language in environment
        if (countryCode == 'BD' || countryCode == 'CN') {
          languageCode = environment.defaultLanguage;
        }

        // Set MY/EN for myr domain, otherwise default to BD/BN for qp10
        if (environment.projectCode === 'qp10') {
          if (this.hostname.includes('myr')) {
            localStorage.setItem('country_code', "MY");
            localStorage.setItem('language_code', "EN");
          } else {
            localStorage.setItem('country_code', "BD");
            localStorage.setItem('language_code', "BN");
          }
        }

        if (localStorage.getItem('language_code') === null) {
          localStorage.setItem('language_code', language_code);
          this.translateService.use(language_code.toLocaleLowerCase());
        }
      }

      // LocalHost or Staging
      else if (this.hostname === 'localhost' || !environment.production) {
        if (localStorage.getItem('country_code') === null) {
          if (environment.projectCode === 'qp8') {
            localStorage.setItem('country_code', "BD");
          } else if (environment.projectCode === 'qp20-dark') {
            localStorage.setItem('country_code', "CN");
          }
          else if (environment.projectCode === 'qp10') {
            localStorage.setItem('country_code', "BD");
            localStorage.setItem('language_code', "BN");
          }
          else {
            localStorage.setItem('country_code', "MY");
          }
        }
        if (localStorage.getItem('language_code') === null) {
          localStorage.setItem('language_code', "EN"); // Set to default value if null
          this.translateService.use('en');
        }
      }
    }

    // Auto login part
    if (urlParams.get('userToken')) {
      const userToken = urlParams.get('userToken');
      const userData = urlParams.get('userData');
      localStorage.setItem('user_token', userToken);
      localStorage.setItem('user_data', userData);
      const newURL = location.href.split('?')[0];
      window.history.pushState('object', document.title, newURL);
    }

    this.eventEmitterService.onFlagEmitter();

    this.logoFaviconHttpService.updateLogoAndFavicon();
  }

  private async checkLocation() {
    const pathname = window.location.pathname;
    const isNonProdEnv = environment.domainEnv === 'demo' || environment.domainEnv === 'staging' || environment.domainEnv === 'qa';
    const noticeDismissed = sessionStorage.getItem(ShowChangeCountryNoticeKey);
    if ((environment.production || isNonProdEnv)
      && pathname !== '/landing'
      && pathname !== '/'
      && this.hostname !== 'localhost'
      && !this.authService.getLoginStatus()
      && (noticeDismissed == null || +noticeDismissed == 1)) {
      // THIS PART COMMENTED BECAUSE DONT WANT TO USE COORDINATES (GEO-LOCATION) TO GET USER LOCATION, geoLocationError FUNCTION IS USE IP ADDRESS TO GET USER LOCATION
      // if (navigator.geolocation) {
      //   const position = await this.getCoordinates();
      //   if (position['coords']) {
      //     this.geoLocationSuccess(position);
      //   } else {
      //     this.geoLocationError();
      //   }
      // } else {
      this.geoLocationError();
      // }
    } else if (environment.production
      /* DomainService already resolved this host on the server: toLanding for a landing
         domain (build-time or BO-published), currentDomainSet for a matched playing domain.
         Use that answer instead of the old `pathname !== '/landing'` + hostname checks —
         landing now lives at '/' (app.routes.ts normalizes '/landing' to it), so that path
         test could never be false and every BO-published landing host was treated as
         unsupported and bounced to environment.domainName. */
      && !this.domainService.getToLanding()
      && !this.domainService.getIsNonRegionalDomain()
      && this.domainService.getCurrentDomainSet() == null) {
      this.isLoggedIn$.subscribe(res => {
        if (!JSON.stringify(this.supportedCountry[this.currentDomain]).includes('"' + this.hostname + '"') && !res) {
          this.alertCountryNotSupported();
        }
      });
    }
  }

  private getCoordinates() {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, resolve, { timeout: 5000 });
    });
  }

  private geoLocationSuccess(position: any) {
    const getCountryISO2 = countryISOMapping;
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    this.locationHttpService.getByCoordinates(longitude, latitude).subscribe(res => {
      const iso2CountryCode = getCountryISO2(res.CountryCode)
      if (iso2CountryCode != localStorage.getItem('country_code') && this.isCountrySupported(iso2CountryCode)) {
        this.showChangeCountryNotice = true;
        this.countryCodeToChange = iso2CountryCode;
      }
    })
  }

  private geoLocationError() {
    this.locationHttpService.getIpAddress().subscribe((res: any) => {
      if (res['country_code']) {
        this.geolocationChange(res['country_code'].toUpperCase());
      } else {
        $.getJSON(`https://geolocation-db.com/json/${res['ip']}`).then((res: any) => {
          this.geolocationChange(res.country_code.toUpperCase());
        })
      }
    })
  }

  private geolocationChange(country_code: string) {
    if (country_code != this.domainService.getCountryCode() && this.isCountrySupported(country_code)) {
      this.countryCodeToChange = country_code;
      this.showChangeCountryNotice = true;
    }
  }

  private isCountrySupported(countryCode: string | null | undefined): boolean {
    const cc = (countryCode || '').toString().trim().toUpperCase();
    if (!cc) return false;
    if ((this.supportedCountry as any)?.[this.currentDomain]?.[cc]) return true;
    try {
      const domainSet = this.domainService?.getDomainSet?.() as any;
      if (!domainSet) return false;
      for (const domainKey of Object.keys(domainSet)) {
        const perCountry = domainSet?.[domainKey];
        if (!perCountry) continue;
        if (perCountry?.[cc.toLowerCase()] || perCountry?.[cc]) return true;
      }
    } catch {
      // ignore
    }
    return false;
  }

  private getDomainsForCountry(countryCode: string | null | undefined): string[] {
    const cc = (countryCode || '').toString().trim().toUpperCase();
    const envKey = environment.domainEnv;
    if (!cc || !envKey) return [];

    // Prefer the domain set.
    try {
      const domainSet = this.domainService?.getDomainSet?.() as any;
      if (domainSet) {
        const candidates = [
          this.currentDomain,
          environment.domainName,
          environment.altDomainName,
          environment.altDomainNameTwo,
        ].filter(Boolean);

        for (const dk of candidates) {
          const perCountry = domainSet?.[dk];
          const cfg = perCountry?.[cc.toLowerCase()] || perCountry?.[cc];
          const list = cfg?.[envKey];
          if (Array.isArray(list) && list.length) return list;
        }

        // Fallback scan across any keys if aliasing differs.
        for (const dk of Object.keys(domainSet)) {
          const perCountry = domainSet?.[dk];
          const cfg = perCountry?.[cc.toLowerCase()] || perCountry?.[cc];
          const list = cfg?.[envKey];
          if (Array.isArray(list) && list.length) return list;
        }
      }
    } catch {
      // ignore and fall back to static
    }

    // Static dropdown fallback.
    const staticCfg = (this.supportedCountry as any)?.[this.currentDomain]?.[cc];
    const staticList = staticCfg?.[envKey];
    return Array.isArray(staticList) ? staticList : [];
  }

  private isHostnameInCountryEnvList(countryCode: string | null | undefined, hostname: string): boolean {
    const host = (hostname || '').toString().trim().toLowerCase();
    if (!host) return false;
    const list = this.getDomainsForCountry(countryCode);
    return list.map((x) => (x || '').toString().trim().toLowerCase()).includes(host);
  }

  private afterOnVerification() {
    this.isLoggedIn$.subscribe(res => {
      if (res) {
        this.router.navigate(['/member/profile']);
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  onChangeCountrySite() {
    const cc = (this.countryCodeToChange || '').toString().toUpperCase();

    const currentHost = (window.location.hostname).replace(/^([w]{3}.)(?=[a-z0-9]+)/, '');

    const servesEveryCountry = this.domainService.getIsNonRegionalDomain()
      || [environment.domainName, environment.altDomainName, environment.altDomainNameTwo]
        .filter(Boolean).includes(currentHost);

    const path = `/${this.domainService.getLanguageCode().toLowerCase()}-${cc.toLowerCase()}${this.domainService.getCurrentPath()}`;
    const marketing = (this.domainService.getMarketingParams() || '').replace(/^\?/, '');
    let query = `?mode=${this.domainService.getSiteMode() == 'member only' ? 'clean' : 'normal'}`;
    if (marketing) query += `&${marketing}`;

    if (servesEveryCountry) {
      window.location.assign(path + query);
      return;
    }

    const domains = this.getDomainsForCountry(cc);
    const target = (domains && domains.length ? domains[0] : null);
    if (!target) return;

    var url = (environment.https ? 'https://' : '//') + target + path + query;
    window.location.assign(url);
  }

  onDismissChangeCountryNotice() {
    this.showChangeCountryNotice = false;
    sessionStorage.setItem(ShowChangeCountryNoticeKey, '0');
  }

  private alertCountryNotSupported() {
    if (this.mainDomainBlocked) {
      var url = (environment.https ? 'https://' : '//') + environment.altDomainName;
    } else if (this.bothDomainBlocked) {
      var url = (environment.https ? 'https://' : '//') + environment.altDomainNameTwo;
    } else {
      var url = (environment.https ? 'https://' : '//') + environment.domainName;
    }
    // // Direct redirect to landing page
    // if (environment.projectCode !== 'qp11-dark') {
    //   window.location.assign(url + '/landing');
    // }
    /* Direct redirect to landing page. Root, not '/landing' — that path only redirects
       to '/' now, so keeping it here just costs an extra hop. */
    if (!['qp11-dark', 'qp20-dark'].includes(environment.projectCode)) {
      window.location.assign(url);
    }
  }

  private redirectToS3Link() {
    if (this.s3RedirectURL[this.pathName]) {
      var redirectURL = this.s3RedirectURL[this.pathName] + '';
      var countryCode = localStorage.getItem('country_code');
      var languageCode = this.pathName.substr(1, 2);
      redirectURL = redirectURL.replace('#COUNTRY_LANGUAGE', countryCode + '_' + languageCode);
      window.location.href = redirectURL;
    }
  }

  private getHostname() {
    // E.g: localhost.com
    // Get localhost.com

    console.log("this.supportedCountry : ", this.supportedCountry);
    console.log("environment.altDomainNameTwo : ", environment.altDomainNameTwo);
    console.log("this.hostname : ", this.hostname);
    
    if (this.hostname == environment.altDomainName || (this.supportedCountry[environment.altDomainName] && JSON.stringify(this.supportedCountry[environment.altDomainName]).includes('"' + this.hostname + '"'))) {
      sessionStorage.setItem('mainDomainBlocked', 'true');
      this.mainDomainBlocked = true;
      this.currentDomain = environment.altDomainName;
    } else if (this.hostname == environment.altDomainNameTwo || (this.supportedCountry[environment.altDomainNameTwo] && JSON.stringify(this.supportedCountry[environment.altDomainNameTwo]).includes('"' + this.hostname + '"'))) {
      sessionStorage.setItem('bothDomainBlocked', 'true');
      this.bothDomainBlocked = true;
      this.currentDomain = environment.altDomainNameTwo;
    } else {
      sessionStorage.removeItem('mainDomainBlocked');
      this.mainDomainBlocked = false;
      this.currentDomain = environment.domainName;
    }
  }

  private async getAllGameProvider() {
    if (localStorage.getItem('available_providers') == null) {
      await this.gameCategoryDataService.getAllGameProvider().toPromise();
      this.eventEmitterService.onTopBarTabEmitter();
    }
  }

  /**
   * AIO-82885: BO chooses the chat provider, and the two can never both draw a launcher.
   * Skynet configured => the widget, and startLiveChat() is never reached; not configured =>
   * exactly what this method always did. A brand with no settings row is the rollback.
   *
   * The jackpot websocket moved out here on purpose: it has nothing to do with chat and has
   * lived inside this method since the port, so it must run on both branches.
   */
  private getLiveChatScript() {

    this.supportChatService.start(() => this.startLiveChat());
  }

  private startLiveChat() {
    var language = localStorage.getItem('language_code');
    var country = localStorage.getItem('country_code');
    var user = JSON.parse(localStorage.getItem('user_data'));
    const memberGroupCodeParam = user ? ('&member_group_code='+user['member_group']['code'].toLowerCase()) : '';

    var liveChatScriptID = "live-chat-script";

    this.siteHttpService.getLiveChatScript(`?merchant=${environment.projectCode}&language=${language}&country=${country}${memberGroupCodeParam}`).subscribe(res => {
    if (this.siteHttpService.website !== null && this.siteHttpService.website !== '') {
          
            var website = this.siteHttpService.website;

            // Check live chat <script> is it exists.
            var scriptIndex = website.indexOf('<script') + '<script'.length;
            website = website.slice(0, scriptIndex) + ' id="' + liveChatScriptID + '" ' + website.slice(scriptIndex, website.length);
            
            var scriptExists = (document.getElementById(liveChatScriptID) !== null);

            if (this.siteHttpService.live_chat_platform_name == 'Live Chat') {
              // Remove old live chat <script> if already exists.
              if (scriptExists) {
                var scriptElement = document.getElementById(liveChatScriptID);
                if (scriptElement != null) {
                  scriptElement.parentNode.removeChild(scriptElement);
                }
              }

              // website = website.replace(/(['])/g, "\\$1");
              var index = website.indexOf('window.__lc.license');
              var username = "  ";
              var email = "  ";

              if (localStorage.getItem('user_data') != null) {
                  if (JSON.parse(localStorage.getItem('user_data')).username != null && JSON.parse(localStorage.getItem('user_data')).username !== '') {
                    username = JSON.parse(localStorage.getItem('user_data')).username;
                  }
                  if (JSON.parse(localStorage.getItem('user_data')).email != null && JSON.parse(localStorage.getItem('user_data')).email !== '') {
                    email = JSON.parse(localStorage.getItem('user_data')).email;
                  }
                
                if (index > 0) {
                  website = website.slice(0, index) + "window.__lc.visitor = {name: '" + username + "',email: '" + email + "'};" + website.slice(index, website.length);
                }
              }

              const visitorScript = `window.__lc.visitor = {name: '${username}', email: '${email}'};`;
              if (website.includes('window.__lc.visitor')) {
                website = website.replace(/window\.__lc\.visitor\s*=\s*\{[^}]*\};?/g, visitorScript);
              } else if (website.includes('window.__lc.license')) {
                const index = website.indexOf('window.__lc.license');
                website = website.slice(0, index) + visitorScript + website.slice(index);
              }

              else {
                if (index > 0) {
                  website = website.slice(0, index) + website.slice(index, website.length);
                }
              }

              $(website).appendTo(document.body); 
              // Setup custom variables after widget loaded
               this.setLiveChatCustomVariable();
            } else if (this.siteHttpService.live_chat_platform_name == 'Crisp') {

              // Crisp no need to remove and assign again due to after assign it require refresh only can work.
              if (!scriptExists || typeof window.$crisp === "undefined") {
                $(website).appendTo(document.body);
                var indexStart = website.indexOf('window.CRISP_WEBSITE_ID=') + 'window.CRISP_WEBSITE_ID='.length;
                var indexEnd = website.indexOf(';(function(){d=document');
                var websiteID = website.slice(indexStart, indexEnd).replace(/\\/g, "").replace(/\"/g, "");

                Crisp.configure(websiteID);
              }

              if (localStorage.getItem('user_data') != null) {
                if (localStorage.getItem('user_data') != null) {
                  if (JSON.parse(localStorage.getItem('user_data')).username != null && JSON.parse(localStorage.getItem('user_data')).username !== '') {
                    Crisp.user.setNickname(JSON.parse(localStorage.getItem('user_data')).username);
                  }
                  if (JSON.parse(localStorage.getItem('user_data')).email != null && JSON.parse(localStorage.getItem('user_data')).email !== '') {
                    Crisp.user.setEmail(JSON.parse(localStorage.getItem('user_data')).email);
                  }
                }
              }

            }
        }else{
          // Remove old live chat <script> if already exists.
          if (scriptExists) {
              var scriptElement = document.getElementById(liveChatScriptID);
              if (scriptElement != null) {      
                  scriptElement.parentNode.removeChild(scriptElement);
                  document.getElementById("chat-widget-container").parentNode.removeChild(document.getElementById("chat-widget-container"));
              }
              this.liveChatHttpService.clearCookies();
          }            
        }
    });
  }

  private setLiveChatCustomVariable() {
    this.isLoggedIn$.subscribe(res => {
      if (res) {
        setTimeout(async () => {
          const liveChatTranslate: any = this.liveChatHttpService.getTranslation();
          const apiParams = [];

          if (!this.liveChatHttpService.getInfoOngoing) {
            const cookieData = this.liveChatHttpService.getLiveChatInfoCookies();
            if (!cookieData['username']) { apiParams.push('username'); }
            if (!cookieData['membership']) { apiParams.push('membership'); }
            if (!cookieData['balance']) { apiParams.push('balance'); }
            if (!cookieData['last_played_game']) { apiParams.push('last_played_game'); }
            if (!cookieData['kyc_status']) { apiParams.push('kyc_status'); }
            if (!cookieData['next_required_deposit']) { apiParams.push('next_required_deposit'); }
            if( apiParams.length > 0 ) {
              this.liveChatHttpService.getLiveChatInfo(apiParams).subscribe(apiData => {
                const mergedData = { ...cookieData, ...apiData };
                const lcCustomVariables = Object.keys(mergedData).reduce((acc: any, key) => {
                  acc[liveChatTranslate[key]] = mergedData[key];
                  return acc;
                }, {});
                window.LiveChatWidget.call('set_session_variables', lcCustomVariables);
              });
            } else {
              const lcCustomVariables = Object.keys(cookieData).reduce((acc: any, key) => {
                acc[liveChatTranslate[key]] = cookieData[key];
                return acc;
              }, {});
              window.LiveChatWidget.call('set_session_variables', lcCustomVariables);
            }
          }
        }, 500)
      }
    });
  }

  private setSessionStorage(countryCode: string) {
    this.bankHttpService.getAllBanks().subscribe(res => {
      sessionStorage.setItem('all_bank', JSON.stringify(res))
    });
    this.gameCategoryHttpService.getCategoryList().subscribe(res => {
      sessionStorage.setItem('game_category_list', JSON.stringify(res))
    });
    this.merchantBankHttpService.getMerchantBankDeposits().subscribe(res => {
      sessionStorage.setItem('member_merchant_bank', JSON.stringify(res))
    });
    this.bankAccountDataService.getAll().subscribe(res => {
      sessionStorage.setItem('member_bank_accounts', JSON.stringify(res))
    });
  }

  private setWidget() {
    this.promotionContentDataService.getWidget().subscribe(res => {
      this.widget = res;
    });
  }

  getPromotion() {
    return new Promise<void>((resolve) => {
      this.promotionContentDataService.getPromotion().pipe(
        tap(res => {
          const bonusPromotion = res.filter((x: any) => x.open === 1);
          var bonus = JSON.parse(localStorage.getItem("bonus"));
          var bonus_notice = false;

          if (bonusPromotion.length > 0) {
            if (localStorage.getItem("bonus") !== null) {
              bonus_notice = bonus.bonus_notice;

              if (bonusPromotion.length > bonus.bonus_list.length) {
                bonus_notice = true;
              }
            } else {
              bonus_notice = true;
            }
          }

          localStorage.setItem('bonus', JSON.stringify({
            bonus_notice: bonus_notice,
            bonus_list: bonusPromotion
          }));
          resolve();
        })
      ).subscribe();
    });
  }

  ngAfterViewInit() {
    if (!this.isBrowser) return;
    // The widget overlays the withdraw form, so it is kept off that page (as in template-02).
    if (localStorage.getItem('user_data') != null && !window.location.pathname.startsWith('/member/withdraw')) {
      this.getMiniGameScript();
    }
  }

  checkForDialogParam() {
    const url = this.router.url;
    if (url.includes('dialog=1')) {
      // this.dialog.open(FreeSpinComponent, { width: 'auto' });
      localStorage.setItem('freespin_dialog', '1');
    } else if (url.includes('dialog=2')) {
      // this.dialog.open(FreeSpinComponent, { width: 'auto' });
      localStorage.setItem('freespin_dialog', '2');
    } else if (url.includes('dialog=3')) {
      // this.dialog.open(FreeSpinComponent, { width: 'auto' });
      localStorage.setItem('freespin_dialog', '3');
    }
  }

  private getMiniGameScript() {
    // template-02 guards this with authService.isTokenExpired(), which -- because
    // checkTokenExpiration() always returns false -- only ever means "no user_token".
    // Ported as that literal check rather than reproducing the dead expiry branch.
    if (localStorage.getItem('user_token') == null) {
      return;
    }

    this.siteHttpService.getMiniGameScript().subscribe(res => {
      Object.keys(res).forEach(key => {
        var miniGameScript = res[key].locales[0].script;
        var token = res[key].token;
        if (token != null) {
          $(miniGameScript).appendTo(document.body);
          setTimeout(() => {
            lotee.init(token);
          }, 1500)
        }
      })
    });
  }

  /**
   * AIO-82318: a two-step deposit reserved on another device or before the last reload is still
   * waiting to be paid. Restore it into localStorage so the deposit page can resume at step 2,
   * and — unless the member is already on that page — offer to continue or cancel it.
   *
   * Only applies to the two-step flow (deposit_whitelist == 1); the one-step bank transfer and
   * the payment gateway reserve nothing.
   */
  private checkPendingPaymentTwostepDeposit() {
    const depositWhitelist = JSON.parse(
      localStorage.getItem('user_data') ?? localStorage.getItem('memberProfile') ?? '{}'
    )?.deposit_whitelist ?? 0;

    if (depositWhitelist != 1) {
      return;
    }

    this.newDepositHttpService.getPendingPaymentTwostepDeposit().subscribe(pendingRes => {
      if (!pendingRes.success) {
        return;
      }

      /* Nothing pending server-side: whatever TwostepDeposit still holds was paid, cancelled or
         expired elsewhere, so drop it rather than let the deposit page resume a dead reservation. */
      if (!pendingRes.data?.rows?.deposit) {
        this.newTwostepDepositDataService.clearLocalStorage();
        return;
      }

      this.newTwostepDepositDataService.storeLocalStorage({ ...pendingRes.data.rows });

      if (this.router.url.includes('/member/deposit')) {
        return;
      }

      Swal.fire({
        customClass: {
          denyButton: 'deny-button',
          confirmButton: 'confirm-button',
        },
        html: '<div class="alert-svg alert-svg-' + environment.projectCode + '">' + (environment.projectCode === 'qp20-dark' ? this.svg.triangleAlertIcon : this.svg.alertIcon) + '</div>' +
          '<div class="text-center mt-4 mb-3">' + this.translateService.instant(this.newTwostepDepositDataService.getRedirectPageMsg()) + '</div>',
        showConfirmButton: true,
        showDenyButton: true,
        showCloseButton: true,
        reverseButtons: true,
        confirmButtonText: this.translateService.instant('Continue Payment'),
        denyButtonText: this.translateService.instant('Cancel Deposit'),
      }).then(result => {
        if (result.isConfirmed) {
          this.router.navigate(['/member/deposit']);
        } else if (result.isDenied) {
          this.newDepositHttpService.cancelTwostepDeposit(pendingRes.data.rows.deposit.id).subscribe(() => {
            this.newTwostepDepositDataService.clearLocalStorage();
          });
        }
      });
    });
  }

  private onRefreshBalance() {
    if (window.location.pathname === '/gamelaunch' || this.isExcludedInsufficientFundsRoute()) {
      return;
    }

    // `allbalance` already folds the game-provider balances into `balance`, so there is no
    // need to wait on `game_category_list` in sessionStorage. The previous implementation
    // polled it on a 500ms interval that was only cleared once `total_game_balance` showed
    // up -- when it never did (logged-out race, provider call failing) the timer ran for the
    // lifetime of the tab. Pass false so this probe does not publish over the topbar balance.
    this.walletHttpService.getAllBalance(false).subscribe((wallet) => {
      const rawBalance = wallet?.balance;
      const totalBalance = Number(rawBalance);
      if (
        rawBalance == null ||
        String(rawBalance).trim() === '' ||
        !Number.isFinite(totalBalance)
      ) {
        return;
      }

      this.dashboardService.refreshMemberBalance(totalBalance);

      if (
        totalBalance <= 0 &&
        localStorage.getItem('reward_notice') == '0' &&
        localStorage.getItem('announcements_pop_available') == '0' &&
        localStorage.getItem('insufficient_balance_popup') != '0' &&
        this.inSufficientPopup &&
        !this.isExcludedInsufficientFundsRoute()
      ) {
        this.inSufficientPopup = false;
        this.openInsufficient(InsufficientModalModalComponent);
      }
    });
  }

  private openInsufficient(componentRef: any) {
    this.dialog.open(componentRef);
  }

  private isExcludedInsufficientFundsRoute(): boolean {
    return ['/processing-transaction', '/new-processing-transaction']
      .some(path => window.location.pathname.endsWith(path));
  }


  listenToWssEventSettingChanges() {
    this.wssEventSettingService.listenToWssEventSettingUpdates();

    this.wssEventSettingService.wssStatusChanged$.subscribe(({ event_name, status }) => {
      if (event_name === 'member-online') {
        if (status === 1) {
          this.socketIoService.join('member-online');
        }
      }
    });
  }

  private listenToForceLogoutEvents() {
    const userToken = JSON.parse(localStorage.getItem('user_token') || '{}');
    const accessToken = userToken?.access_token;
    
    if (!accessToken) return;

    const channelName = `force-logout-channel_${accessToken}`;
    this.unsubscribeForceLogout = this.socketIoService.channel(channelName).listen('ForceLogoutEvent', (data: { reason: string }) => {
      Swal.fire({
        html: '<i class="icon-exclamation-triangle alert-icon-fail"></i>' +
          '<div class="text-center m-t-20">' +
          data.reason +
          '</div>',
        showCloseButton: true,
      });
      this.store.dispatch(Logout());

      setTimeout(() => {
        window.location.reload();
      }, 500);
    });
  }

  continueOTPCounter(){
    let mobile_otp_timer = parseInt(sessionStorage.getItem('OTP_timer'));
    
    if (mobile_otp_timer !== null && !Number.isNaN(mobile_otp_timer)) {
      let timer:any;
      this.eventEmitterService.onVerificationTimerEmitter('OTP_timer');
      window.clearInterval(timer);
      timer = setInterval(() => {
        mobile_otp_timer--;
        sessionStorage.setItem('OTP_timer', mobile_otp_timer.toString());
        if (mobile_otp_timer === 0) {
          window.clearInterval(timer);
          sessionStorage.removeItem('OTP_timer');
        }
      }, 1000);
    }else{
      sessionStorage.removeItem('OTP_timer');
    }
  }

  private prefetchMarqueeAndMaintenanceToStorage(): void {
    forkJoin({
      marquees: this.announcementHttpService.getMarquees(),
      maintenance: this.announcementHttpService.getMaintenance()
    }).subscribe({
      next: ({ marquees, maintenance }) => {
        try {
          localStorage.setItem('marquee', JSON.stringify(marquees || []));
          localStorage.setItem('marquees', JSON.stringify(marquees || []));

          const maintPayload = maintenance || { rows: [], empty_message: '' };
          localStorage.setItem('game_provider_maintenance', JSON.stringify(maintPayload));
        } catch { /* ignore quota/JSON errors */ }
      },
      error: () => {
        try {
          if (!localStorage.getItem('game_provider_maintenance')) {
            localStorage.setItem('game_provider_maintenance', JSON.stringify({ rows: [], empty_message: '' }));
          }
        } catch {}
      }
    });
  }

  private loadClarity(): void {
    // Per-brand Microsoft Clarity. Loads once and tracks clicks/heatmaps/session
    // recordings across the whole site.
    // Skip entirely for brands with no clarityProjectId configured.
    // Wrapped in try/catch — tag injection must never break app bootstrap.
    try {
      const clarityProjectId = (environment as any).clarityProjectId;
      if (!clarityProjectId) {
        return;
      }

      const script = document.createElement('script');
      script.text = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, "clarity", "script", "${clarityProjectId}");`;
      document.head.appendChild(script);

      /* AIO-81499: consent, then the custom tags. The snippet above defines window.clarity
         as a queueing stub synchronously, so these are held until the tag loads. Consent
         matters most — without it Clarity cannot keep _clck/_clsk and every page load
         files as a NEW user and a NEW session. */
      this.clarityService.grantCookieConsent();
      this.clarityService.setSessionTags();
    } catch {
      // swallow — Clarity failure must not disrupt the app
    }
  }

  /**
   * AIO-82875: after sign-in, register this device for push - only for a member who has push ON, so
   * nobody gets a browser prompt they did not ask for (switching it on later asks from the Profile
   * page) - and show pushes that arrive while the app is open.
   */
  private startPushNotifications(): void {
    if (!this.isBrowser || window.location.pathname === '/gamelaunch') {
      return;
    }

    /* On the next tick: the login effect stores the token this request needs after isLoggedIn$ fires.
       A failed profile call means no prompt this time - the next sign-in asks. */
    setTimeout(() => {
      this.portalMemberProfileHttpService.getProfile().subscribe({
        next: (profile: any) => {
          if (Number(profile?.settings?.push_noti) === 1) {
            /* Firefox and Safari show the permission prompt only from a tap: there this registers a device
               that already said yes, and offers a tap for the rest. */
            if (canAskPushWithoutTap(false)) {
              this.firebaseMessagingService.requestPermission(true);
            } else {
              this.firebaseMessagingService.requestPermission(false);
              this.offerPushPermission();
            }
          }
        },
        error: () => { },
      });
    });

    if (this.pushMessagesListening) {
      return;
    }

    this.pushMessagesListening = true;
    this.firebaseMessagingService.listenToMessages().subscribe((payload) => {
      /* The browser shows nothing for a message that arrives while the app is open */
      const notice = this.firebaseMessagingService.foregroundNotice(payload);

      if (notice) {
        this.firebaseMessagingService.showNotice(notice, 8000);
      }
    });
  }

  /** AIO-82875: ask for push permission from a tap - once per launch, until the member answers the browser prompt. */
  private offerPushPermission(): void {
    if (this.pushPermissionOffered || this.firebaseMessagingService.permissionState() !== 'default') {
      return;
    }

    this.pushPermissionOffered = true;
    this.firebaseMessagingService.showNotice({
      title: this.translateService.instant('Push Notification'),
      body: this.translateService.instant('Turn on notifications to get updates on this device.'),
      buttonConfirm: this.translateService.instant('Confirm'),
      buttonCancel: this.translateService.instant('Later'),
      onConfirm: () => this.firebaseMessagingService.enableFromGesture(),
    });
  }
}
